
import { productQuantityOrderedStyles } from "@insite/content-library/Components/ProductQuantityOrdered";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";
import { css } from "styled-components";

productQuantityOrderedStyles.cssOverrides= {
	formInputWrapper: css`
		input{
			border:1px solid ${WhitecapColors.borderColor};
			background: ${WhitecapColors.white} !important;
    		border-width: 1px !important;
		}
	`,
}